var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4014",
    xmlSpace: "preserve",
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4018"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4026"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4048"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4046"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4020",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4024",
    clipPath: "url(#clipPath4028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4030",
    transform: "translate(497,301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -100,100 V -40 H 0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4032"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4034",
    transform: "translate(437,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 60 V 170 L -39.995,270 H -100 V 130 H -422 V 0 h 60",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4036"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4038",
    transform: "translate(195,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 122",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4050",
    transform: "translate(195,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-33.137 -26.863,-60 -60,-60 -33.137,0 -60,26.863 -60,60 0,33.137 26.863,60 60,60 C -26.863,60 0,33.137 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4054",
    transform: "translate(150,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 -6.716,-15 -15,-15 -8.284,0 -15,6.716 -15,15 0,8.284 6.716,15 15,15 C -6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4056"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4058",
    transform: "translate(317,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-33.137 26.863,-60 60,-60 33.137,0 60,26.863 60,60 C 120,33.137 93.137,60 60,60 26.863,60 0,33.137 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4060"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4062",
    transform: "translate(362,131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-8.284 6.716,-15 15,-15 8.284,0 15,6.716 15,15 C 30,8.284 23.284,15 15,15 6.716,15 0,8.284 0,0",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4064"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4066",
    transform: "translate(257,401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-22.092 -17.909,-40 -40,-40 -22.091,0 -40,17.908 -40,40 0,22.092 17.909,40 40,40 C -17.909,40 0,22.092 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4068"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4070",
    transform: "translate(277,261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -120 v 40 c 0,33.137 26.863,60 60,60 33.137,0 60,-26.863 60,-60 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4072"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4074",
    transform: "translate(137,401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-22.092 -17.909,-40 -40,-40 -22.091,0 -40,17.908 -40,40 0,22.092 17.909,40 40,40 C -17.909,40 0,22.092 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4076"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4078",
    transform: "translate(157,261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -120 v 40 c 0,33.137 26.863,60 60,60 33.137,0 60,-26.863 60,-60 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4080"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportPerson);
export default __webpack_public_path__ + "static/media/transport-person.70fff1965fb1ea6d3a2247aaac80fcf9.svg";
export { ForwardRef as ReactComponent };